import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskJoinInvitationVm } from '../my-osk-join-invitation-vm.model';
import { IMyOskJoinInvitationResendIm } from '../my-osk-join-invitation-resend-im.model';
@Injectable({ providedIn: 'root' })
export class MyOskJoinInvitationResendService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskJoinInvitationResend`;
  }
  post(myOskJoinInvitationResendIm: IMyOskJoinInvitationResendIm): Observable<IMyOskJoinInvitationVm> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskJoinInvitationVm>(this.baseUrl, myOskJoinInvitationResendIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
